import { Hexagon, Box, Triangle, Circle, Diamond, Square } from "lucide-react";

const clients = [
  { icon: Hexagon, name: "Hexform" },
  { icon: Box, name: "Kubex" },
  { icon: Triangle, name: "Trilogy" },
  { icon: Circle, name: "Orbital" },
  { icon: Diamond, name: "Diadem" },
  { icon: Square, name: "Squarehead" },
];

export default function Clients() {
  return (
    <section
      data-testid="clients-section"
      className="py-20 md:py-28 border-b border-zinc-200"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between mb-10 flex-wrap gap-4">
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">
            [ TRUSTED BY OPERATORS AT ]
          </div>
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">
            6 / 6 — LOGOS
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-10 gap-x-6">
          {clients.map(({ icon: Icon, name }, i) => (
            <div
              key={name}
              data-testid={`client-logo-${i}`}
              className="group flex items-center gap-3 text-zinc-400 hover:text-zinc-950 transition-colors duration-300"
            >
              <Icon
                className="w-6 h-6 group-hover:text-[#002FA7] transition-colors"
                strokeWidth={1.5}
              />
              <span className="font-display font-bold uppercase tracking-tight text-lg">
                {name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
